import { Link } from "react-router-dom";

const footerLinks = {
  Insurance: [
    { label: "Health Insurance", href: "/health-insurance" },
    { label: "Health Insurers & Brochures", href: "/health-insurance-companies" },
    { label: "Term Insurance", href: "/term-insurance" },
    { label: "Life Insurance", href: "/life-insurance" },
    { label: "Car Insurance", href: "/car-insurance" },
    { label: "Travel Insurance", href: "/travel-insurance" },
    { label: "Marine Insurance", href: "/marine-insurance" },
    { label: "Corporate Insurance", href: "/corporate-insurance" },
    { label: "Group Health Insurance", href: "/group-health-insurance" },
  ],
  Investments: [
    { label: "Mutual Funds", href: "/mutual-funds" },
    { label: "SIP Investments", href: "/sip-investments" },
    { label: "Retirement Planning", href: "/retirement-planning" },
    { label: "Financial Planning", href: "/financial-planning" },
  ],
  Tools: [
    { label: "Compare Plans", href: "/compare-plans" },
    { label: "Calculators", href: "/calculators" },
    { label: "Claims Assistance", href: "/claims-assistance" },
    { label: "Book Appointment", href: "/book-appointment?source=Footer" },
  ],
  Company: [
    { label: "About Us", href: "/about" },
    { label: "Blog", href: "/blog" },
    { label: "Contact", href: "/contact" },
    { label: "Privacy Policy", href: "/privacy-policy" },
    { label: "Terms of Service", href: "/terms" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 lg:gap-6">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-white">ExpertAdvise.in</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mb-5 max-w-xs">
              India&apos;s most trusted insurance and financial advisory platform. We simplify insurance buying with expert guidance, transparent comparisons, and lifetime claims support.
            </p>
            <div className="space-y-2 text-sm">
              <a href="tel:+919999365655" className="flex items-center gap-2 hover:text-white transition-colors">
                <i className="ri-phone-line text-primary-400"></i>
                +91 99993 65655
              </a>
              <a href="mailto:info@expertadvise.in" className="flex items-center gap-2 hover:text-white transition-colors">
                <i className="ri-mail-line text-primary-400"></i>
                info@expertadvise.in
              </a>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                Mon - Sat: 9:00 AM - 8:00 PM
              </div>
            </div>
            {/* Social */}
            <div className="flex items-center gap-3 mt-5">
              {["facebook", "instagram", "linkedin", "twitter"].map((social) => (
                <a
                  key={social}
                  href={`https://www.${social}.com/expertadvise`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-primary-600 transition-colors"
                >
                  <i className={`ri-${social === "twitter" ? "twitter-x" : social}-line text-white text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-white font-semibold text-sm mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-slate-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Cities */}
        <div className="mt-10 pt-8 border-t border-slate-800">
          <h4 className="text-white font-semibold text-sm mb-3">We Serve Across India</h4>
          <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-slate-500">
            {[
              "Delhi", "Noida", "Greater Noida", "Gurgaon", "Ghaziabad", "Faridabad",
              "Mumbai", "Pune", "Bangalore", "Hyderabad", "Chennai", "Ahmedabad",
              "Jaipur", "Lucknow", "Kolkata", "Indore", "Chandigarh", "Kochi",
            ].map((city) => (
              <Link
                key={city}
                to={`/cities/${city.toLowerCase().replace(/\s+/g, "-")}`}
                className="hover:text-primary-400 transition-colors"
              >
                {city}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>&copy; {new Date().getFullYear()} ExpertAdvise.in. All rights reserved.</p>
          <p>
            <span className="text-slate-600">Registered IRDAI License Holder.</span>{" "}
            <span className="text-slate-600">Insurance is the subject matter of solicitation.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}